export function randomUUID() {
  return crypto.randomUUID();
}
